<script setup lang="ts">
import SectionPaymentPolicy from './payment-policy/SectionPaymentPolicy.vue'

defineOptions({
  name: 'TutorPaymentPolicyPage',
})
</script>

<template>
  <SectionPaymentPolicy />
</template>
